export type LanguageText = {
  createGroup: {
    createAGroup: string;
    createGroup: string;
    labels: {
      groupName: string;
    };
    tooltips: {
      groupName: string;
    };
    toasts: {
      createdSuccessfully: string;
      creationError: string;
    };
    confirm: {
      title: string;
      phrase1: string;
      phrase2: string;
      phrase3: string;
      buttons: {
        create: string;
        cancel: string;
      };
    };
  };
  groupInvite: {
    inviteUser: string;
    email: string;
    buttons: {
      admin: string;
      member: string;
      invite: string;
      cancel: string;
    };
    toasts: {
      invited: string;
    };
  };
  groupTable: {
    groups: string;
    groupName: string;
    tableElements: {
      quickEdit: string;
      searchAllColumns: string;
      goToPage: string;
      show: string;
      noGroupsFound: string;
    };
  };
  joinGroup: {
    phrase1: string;
    phrase2: string;
    phrase3: string;
    error: {
      thereWasAProblem: string;
      ifTheProblemPersists: string;
      pleaseClickEmailLink: string;
    };
    modalElements: {
      title: string;
      accept: string;
      cancel: string;
    };
    toast: {
      joined: string;
      successfully: string;
    };
  };
  viewEditGroup: {
    editGroup: string;
    labels: {
      groupName: string;
      members: string;
      devices: string;
    };
    buttons: {
      save: string;
      cancel: string;
      invite: string;
      leaveGroup: string;
      deleteGroup: string;
    };
    tabs: {
      overview: string;
      members: string;
      devices: string;
      dashboards: string;
      subscription: string;
      notifications: string;
      styles: string;
      logs: string;
    };
    toasts: {
      updated: string;
      deleted: string;
      left: string;
    };
    modals: {
      leaveModal: {
        title: string;
        body: {
          phrase1: string;
          phrase2: string;
        };
        buttons: {
          accept: string;
          cancel: string;
        };
      };
      deleteModal: {
        title: string;
        body: {
          phrase1: React.ReactNode;
          phrase2: React.ReactNode;
        };
        buttons: {
          accept: string;
          cancel: string;
        };
        labels: {
          password: string;
        };
      };
    };
  };
  memberTable: {
    members: string;
    tableElements: {
      headers: {
        userName: string;
        memberID: string;
        joinDate: string;
      };
      quickEdit: string;
      searchAllColumns: string;
      goToPage: string;
      show: string;
      loading: string;
      noMembersFound: string;
    };
    toast: {
      cantEditOwnPerms: string;
    };
  };
  inviteTable: {
    outstandingInvitations: string;
    tableElements: {
      headers: {
        email: string;
        invitedBy: string;
        inviteDate: string;
        cancelInvitation: string;
      };
      noInvitesFound: string;
    };
    toast: {
      cancelSuccess: string;
      cancelError: string;
      updateSuccess: string;
      updateError: string;
    };
    modals: {
      cancelInvite: {
        title: string;
        body: {
          phrase1: string;
          thisUser: string;
          phrase2: string;
          phrase3: string;
        };
        buttons: {
          accept: string;
          cancel: string;
        };
      };
    };
  };
  groupEditUser: {
    toasts: {
      permsEdited: string;
      removed: string;
    };
    modals: {
      removeUser: {
        title: string;
        body: {
          phrase1: string;
          thisUser: string;
          phrase2: string;
          thisGroup: string;
          phrase3: string;
        };
        buttons: {
          accept: string;
          cancel: string;
        };
      };
      transferOwner: {
        title: {
          phrase1: string;
          phrase2: string;
        };
        body: {
          phrase1: string;
          thisGroup: string;
          phrase2: string;
          thisUser: string;
          phrase3: string;
        };
        labels: {
          password: string;
        };
        buttons: {
          accept: string;
          cancel: string;
        };
      };
      editPerms: {
        title: {
          phrase1: string;
          thisUser: string;
          phrase2: string;
        };
        buttons: {
          makeOwner: {
            phrase1: string;
            thisUser: string;
            phrase2: string;
          };
          remove: string;
          accept: string;
          cancel: string;
        };
      };
    };
  };
  groupStyle: {
    general: {
      save: string;
      saving: string;
      activating: string;
      activate: string;
      messages: {
        successfulStyleUpdate: string;
        unsuccessfulStyleUpdate: string;
        successfulLogoUpload: string;
        unsuccessfulLogoUpload: string;
        successfulLogoRemoval: string;
        unsuccessfulLogoRemoval: string;
        successfulActivate: string;
        unsuccessfulActivate: string;
        copiedToClipboard: string
      };
    };
    components: {
      logo: {
        title: string;
      };
      frameColor: {
        title: string;
      };
      siteName: {
        title: string;
      };
      useAtLogin: {
        title: string
        copyLoginURL: string
      };
      GroupStyleUpgradePrompt: {
        title: string;
        subtitle: string;
        linkToAvailablePlans: string
        features: {
          frameColor: {
            title: string;
            description: string
          };
          siteName: {
            title: string;
            description: string
          };
          logo: {
            title: string;
            description: string
          };
          useAtLogin: {
            title: string;
            description: string
          };
        }
      }
    };
  };
  groupSubscription: {
    paid: string;
    pending: string;
    overdue: string;
    cancelled: string;
    invoice: string;
    invoices: string;
    download: string;
    view: string;
    downloadAll: string;
    date: string;
    myPlan: string;
    availablePlans: string;
    amount: string;
    status: string;
    actions: string;
    page: string;
    of: string;
    members: string;
    dashboards: string;
    devices: string;
    dataRetention: string;
    dashboardElements: string;
    free: string;
    unlimited: string;
    month: string;
    monthly: string;
    year: string;
    yearly: string;
    selectPlan: string;
    search: string;
    allStatuses: string;
    allTime: string;
    activeFilters: string;
    last30Days: string;
    last90Days: string;
    lastYear: string;
    thisYear: string;
    viewInvoice: string;
    copyInvoice: string;
    copyInvoiceID: string;
    notificationAlerts: string;
    customStyleAndUseAtLogin: string;
    included: string;
    availableOnTier3: string;
    off: string;
    clear: string;
    next: string;
    previous: string;
    cancel: string;
    all: string;
    downloadFormat: string;
    dateFormat: string;
    months: string;
    years: string;
    day: string;
    days: string;
    chooseFormatFor: string;
    downloadAllInvoices: string;
    noInvoicesAvailable: string;
    noInvoicesDescription: string;
  };
  groupAuditLogs: {
    refresh: string;
    refreshing: string;
    download: string;
    user: string;
    resource: string;
    action: string;
    selectDate: string;
    filterByUser: string;
    filterByResource: string;
    filterByAction: string;
    filterByDate: string;
    clear: string;
    applyfilter: string;
    show: string;
    entries: string;
    email: string;
    time: string;
    details: string;
    cancel: string;
    selected: string;
    owner: string;
    member: string;
    previous: string;
    next: string;
    of: string;
    results: string;
    showing: string;
    to: string;
    today: string;
    thisWeek: string;
    thisMonth: string;
    lastMonth: string;
    lastYear: string;
    customRange: string;
    startDate: string;
    endDate: string;
    date: string;
  };
};
export const English: LanguageText = {
  createGroup: {
    createAGroup: "Create A Group",
    createGroup: "Create Group",
    labels: {
      groupName: "Group Name",
    },
    tooltips: {
      groupName: "Auto fill this value by clicking the link in the email you received",
    },
    toasts: {
      createdSuccessfully: "Group created successfully",
      creationError: "There was an error creating the group",
    },
    confirm: {
      title: "Create Group",
      phrase1: "Are you sure you, ",
      phrase2: ", would like to create a group called ",
      phrase3: "?",
      buttons: {
        create: "Create",
        cancel: "Cancel",
      },
    },
  },
  groupInvite: {
    inviteUser: "Invite User",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Member",
      invite: "Invite",
      cancel: "Cancel",
    },
    toasts: {
      invited: "User invited successfully",
    },
  },
  groupTable: {
    groups: "Groups",
    groupName: "Group Name",
    tableElements: {
      quickEdit: "Quick Edit",
      searchAllColumns: "Search all Columns",
      goToPage: "Go to page",
      show: "Show",
      noGroupsFound: "No groups found",
    },
  },
  joinGroup: {
    phrase1: "Are you sure you",
    phrase2: "would like to join",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "There was an error with the group you are trying to join. Please click the link in the email again.",
      ifTheProblemPersists: "If the problem persists, please contact the group admin or",
      pleaseClickEmailLink:
        "Please click on the link sent to your email to join the group.",
    },
    modalElements: {
      title: "Join Group",
      accept: "Join",
      cancel: "Logout",
    },
    toast: {
      joined: "Joined",
      successfully: "successfully",
    },
  },
  viewEditGroup: {
    editGroup: "Edit Group",
    labels: {
      groupName: "Group Name",
      members: "Members",
      devices: "Devices",
    },
    buttons: {
      save: "Save",
      cancel: "Cancel",
      invite: "Invite",
      leaveGroup: "Leave Group",
      deleteGroup: "Delete Group",
    },
    tabs: {
      overview: "Overview",
      members: "Members",
      devices: "Devices",
      dashboards: "Dashboards",
      subscription: "Subscription",
      notifications: "Notifications",
      styles: "Styles",
      logs: "Logs",
    },
    toasts: {
      updated: "Group updated.",
      deleted: "Group deleted.",
      left: "Left group.",
    },
    modals: {
      leaveModal: {
        title: "Leave Group",
        body: {
          phrase1: ", are you sure you would like to leave ",
          phrase2: "?",
        },
        buttons: {
          accept: "Leave Group",
          cancel: "Cancel",
        },
      },
      deleteModal: {
        title: "Delete Group",
        body: {
          phrase1: (
            <>
              Are you sure that you want to <b>delete</b>
            </>
          ),
          phrase2: "? This action cannot be undone.",
        },
        buttons: {
          accept: "Delete Group",
          cancel: "Cancel",
        },
        labels: {
          password: "Password",
        },
      },
    },
  },
  memberTable: {
    members: "Members",
    tableElements: {
      headers: {
        userName: "User Name",
        memberID: "Member ID",
        joinDate: "Join Date",
      },
      quickEdit: "Quick Edit",
      searchAllColumns: "Search All Columns",
      goToPage: "Go to page",
      show: "Show",
      loading: "Loading",
      noMembersFound: "No members found",
    },
    toast: {
      cantEditOwnPerms: "You aren't able to edit your own permissions",
    },
  },
  inviteTable: {
    outstandingInvitations: "Outstanding Invitations",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Invited By",
        inviteDate: "Invite Date",
        cancelInvitation: "Cancel Invitation",
      },
      noInvitesFound: "No invitations found",
    },
    toast: {
      cancelSuccess: "Invitation successfully cancelled.",
      cancelError: "Problem cancelling invitation. Please try again later.",
      updateSuccess: "Invitation permissions successfully updated.",
      updateError: "Problem updating invitation permissions. Please try again later.",
    },
    modals: {
      cancelInvite: {
        title: "Cancel Invitation",
        body: {
          phrase1: "Are you sure you want to cancel invites to ",
          thisUser: "this user",
          phrase2: "? This will remove all invites to ",
          phrase3: ".",
        },
        buttons: {
          accept: "Cancel Invite(s)",
          cancel: "Cancel",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "User permissions updated",
      removed: "User removed from group",
    },
    modals: {
      removeUser: {
        title: "Remove User",
        body: {
          phrase1: "Remove",
          thisUser: "this user",
          phrase2: "from",
          thisGroup: "this group",
          phrase3: "?",
        },
        buttons: {
          accept: "Remove",
          cancel: "Cancel",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Transfer Ownership to",
          phrase2: "",
        },
        body: {
          phrase1: "Transfer ownership of",
          thisGroup: "this group",
          phrase2: "to",
          thisUser: "this user",
          phrase3:
            "? You will no longer have group ownership. Account password required to continue.",
        },
        labels: {
          password: "Password",
        },
        buttons: {
          accept: "Transfer",
          cancel: "Cancel",
        },
      },
      editPerms: {
        title: {
          phrase1: "Edit Member",
          thisUser: "this user",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Make",
            thisUser: "this user",
            phrase2: "group owner",
          },
          remove: "Remove",
          accept: "Save",
          cancel: "Cancel",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Save",
      saving: "Saving",
      activating: 'Activating...',
      activate: 'Activate',
      messages: {
        successfulLogoUpload: "Logo Successfully Uploaded",
        unsuccessfulLogoUpload: "Could not upload Logo. Please try again later",
        successfulLogoRemoval: "Logo Deleted Successfully",
        unsuccessfulLogoRemoval: "Could not remove Logo. Please try again later",
        successfulStyleUpdate: "Style Updated Successfully",
        unsuccessfulStyleUpdate: "Could not update style. Please try again later",
        successfulActivate: 'Login customisation enabled successfully',
        unsuccessfulActivate: 'Failed to enable login customisation. Please try again',
        copiedToClipboard: 'Copied to clipboard'
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Frame Color",
      },
      siteName: {
        title: "Site Name",
      },
      useAtLogin: {
        title: 'Use at Login',
        copyLoginURL: 'Copy Login URL',
      },
      GroupStyleUpgradePrompt: {
        title: 'Group Style Customisation',
        subtitle: 'Available on Tier 3 and above',
        linkToAvailablePlans: 'Upgrade to unlock',
        features: {
          frameColor: {
            title: 'Brand Color Palette',
            description: "Choose your brand's primary color to unify headers, buttons, and accents throughout the entire group interface",
          },
          siteName: {
            title: 'Company Name Branding',
            description: 'Replace default branding with your company name, displayed consistently across all group pages and components',
          },
          logo: {
            title: 'Upload Company Logo',
            description: 'Upload your company logo to appear in headers, login screens, and key branding areas across the group',
          },
          useAtLogin: {
            title: 'Login Page Branding',
            description: 'Extend your branding to login pages with custom styles and branded URLs for seamless user recognition'
          }
        }
      }
    },
  },
  groupSubscription: {
    paid: "Paid",
    pending: "Pending",
    overdue: "Overdue",
    cancelled: "Cancelled",
    invoice: "Invoice",
    invoices: "Invoices",
    download: "Download",
    view: "View",
    downloadAll: "Download All",
    date: "Date",
    myPlan: "My Plan",
    availablePlans: "Available Plans",
    amount: "Amount",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    members: "Members",
    dashboards: "Dashboards",
    devices: "Devices",
    dataRetention: "Data Retention",
    dashboardElements: "Dashboard Elements",
    free: "Free",
    unlimited: "Unlimited",
    month: "Month",
    monthly: "Monthly",
    year: "Year",
    yearly: "Yearly",
    selectPlan: "Select Plan",
    search: "Search",
    allStatuses: "All Statuses",
    allTime: "All Time",
    activeFilters: "Active Filters",
    last30Days: "Last 30 Days",
    last90Days: "Last 90 Days",
    lastYear: "Last Year",
    thisYear: "This Year",
    viewInvoice: "View Invoice",
    copyInvoice: "Copy Invoice",
    copyInvoiceID: "Copy Invoice ID",
    notificationAlerts: "Notification Alerts",
    customStyleAndUseAtLogin: "Custom style & use style at login",
    included: "Included",
    availableOnTier3: "Available on Tier 3",
    off: "OFF",
    clear: "Clear",
    next: "Next",
    previous: "Previous",
    cancel: "Cancel",
    all: "All",
    downloadFormat: "Download Format",
    dateFormat: "Date Format",
    months: "Months",
    years: "Years",
    day: "Day",
    days: "Days",
    chooseFormatFor: "Choose Format For",
    downloadAllInvoices: "Download All Invoices",
    noInvoicesAvailable: "No Invoices Available",
    noInvoicesDescription:
      "You don't have any invoices yet. Invoices will appear here once your subscription generates billing records.",
  },
  groupAuditLogs: {
    refresh: "Refresh",
    refreshing: "Refreshing",
    download: "Download",
    user: "User",
    resource: "Resource",
    action: "Action",
    selectDate: "Select Date",
    filterByUser: "Filter By User",
    filterByResource: "Filter By Resource",
    filterByAction: "Filter By Action",
    filterByDate: "Filter By Date",
    clear: "Clear",
    applyfilter: "Apply Filter",
    show: "Show",
    entries: "Entries",
    email: "Email",
    time: "Time",
    details: "Details",
    cancel: "Cancel",
    selected: "Selected",
    owner: "Owner",
    member: "Member",
    previous: "Previous",
    next: "Next",
    of: "of",
    results: "results",
    showing: "Showing",
    to: "to",
    today: "Today",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    lastYear: "Last Year",
    customRange: "Custom Range",
    startDate: "Start Date",
    endDate: "End Date",
    date: "Date",
  },
};
export const French: LanguageText = {
  createGroup: {
    createAGroup: "Créer un groupe",
    createGroup: "Créer un groupe",
    labels: {
      groupName: "Nom du groupe",
    },
    tooltips: {
      groupName:
        "Remplissez automatiquement cette valeur en cliquant sur le lien dans l'email que vous avez reçu",
    },
    toasts: {
      createdSuccessfully: "Groupe créé avec succès",
      creationError: "Il y a eu une erreur en créant le groupe",
    },
    confirm: {
      title: "Créer un groupe",
      phrase1: "Êtes-vous sûr que vous, ",
      phrase2: ", voulez créer un groupe appelé ",
      phrase3: "?",
      buttons: {
        create: "Créer",
        cancel: "Annuler",
      },
    },
  },
  groupInvite: {
    inviteUser: "Inviter un utilisateur",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Membre",
      invite: "Invite",
      cancel: "Annuler",
    },
    toasts: {
      invited: "Utilisateur invité avec succès",
    },
  },
  groupTable: {
    groups: "Groupes",
    groupName: "Nom du groupe",
    tableElements: {
      quickEdit: "Édition rapide",
      searchAllColumns: "Rechercher dans toutes les colonnes",
      goToPage: "Aller à la page",
      show: "Afficher",
      noGroupsFound: "Aucun groupe trouvé",
    },
  },
  joinGroup: {
    phrase1: "Êtes-vous sûr que vous, ",
    phrase2: ", voulez rejoindre ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "Il y a eu une erreur avec le groupe que vous essayez de rejoindre. Veuillez cliquer à nouveau sur le lien dans l'e-mail.",
      ifTheProblemPersists:
        "Si le problème persiste, veuillez contacter l'administrateur du groupe ou",
      pleaseClickEmailLink:
        "Veuillez cliquer sur le lien envoyé à votre e-mail pour rejoindre le groupe.",
    },
    modalElements: {
      title: "Rejoindre le groupe",
      accept: "Rejoindre",
      cancel: "Déconnexion",
    },
    toast: {
      joined: "Rejoint",
      successfully: "avec succès",
    },
  },
  viewEditGroup: {
    editGroup: "Modifier le groupe",
    labels: {
      groupName: "Nom du groupe",
      members: "Membres",
      devices: "Dispositifs",
    },
    buttons: {
      save: "Sauvegarder",
      cancel: "Annuler",
      invite: "Invite",
      leaveGroup: "Groupe de congé",
      deleteGroup: "Supprimer le groupe",
    },
    tabs: {
      overview: "Aperçu",
      members: "Membres",
      devices: "Dispositifs",
      dashboards: "Tableaux de bord",
      subscription: "Abonnement",
      notifications: "Notifications",
      styles: "Styles",
      logs: "Journaux",
    },
    toasts: {
      updated: "Groupe mis à jour",
      deleted: "Groupe supprimé.",
      left: "Groupe de gauche.",
    },
    modals: {
      leaveModal: {
        title: "Groupe de congé",
        body: {
          phrase1: ", êtes-vous sûr de vouloir quitter ",
          phrase2: "?",
        },
        buttons: {
          accept: "Groupe de congé",
          cancel: "Annuler",
        },
      },
      deleteModal: {
        title: "Supprimer le groupe",
        body: {
          phrase1: (
            <>
              Êtes-vous sûr de vouloir <b>supprimer</b>
            </>
          ),
          phrase2: "? Cette action ne peut être annulée.",
        },
        buttons: {
          accept: "Supprimer le groupe",
          cancel: "Annuler",
        },
        labels: {
          password: "Mot de passe",
        },
      },
    },
  },
  memberTable: {
    members: "Membres",
    tableElements: {
      headers: {
        userName: "Nom d'utilisateur",
        memberID: "ID du membre",
        joinDate: "Date d'adhésion",
      },
      quickEdit: "Édition rapide",
      searchAllColumns: "Rechercher dans toutes les colonnes",
      goToPage: "Aller à la page",
      show: "Afficher",
      loading: "Chargement",
      noMembersFound: "Aucun membre trouvé",
    },
    toast: {
      cantEditOwnPerms: "Vous n'êtes pas en mesure de modifier vos propres permissions",
    },
  },
  inviteTable: {
    outstandingInvitations: "Invitations sans réponse",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Invité par",
        inviteDate: "Date de l'invitation",
        cancelInvitation: "Annuler l'invitation",
      },
      noInvitesFound: "Aucune invitation trouvée",
    },
    toast: {
      cancelSuccess: "Invitation annulée avec succès.",
      cancelError: "Problème d'annulation d'invitation. Veuillez réessayer plus tard.",
      updateSuccess: "Permissions d'invitation mises à jour avec succès.",
      updateError: "Problème lors de la mise à jour des permissions d'invitation. Veuillez réessayer plus tard.",
    },
    modals: {
      cancelInvite: {
        title: "Annuler l'invitation",
        body: {
          phrase1: "Êtes-vous sûr de vouloir annuler les invitations à ",
          thisUser: "cet utilisateur",
          phrase2: "? Cela supprimera toutes les invitations à ",
          phrase3: ".",
        },
        buttons: {
          accept: "Annuler l'invitation (les invitations)",
          cancel: "Annuler",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Permissions d'utilisateur mises à jour",
      removed: "Utilisateur retiré du groupe",
    },
    modals: {
      removeUser: {
        title: "Supprimer l'utilisateur",
        body: {
          phrase1: "Supprimer ",
          thisUser: "cet utilisateur",
          phrase2: "du",
          thisGroup: "ce groupe",
          phrase3: "?",
        },
        buttons: {
          accept: "Supprimer",
          cancel: "Annuler",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Transférer la propriété à ",
          phrase2: "",
        },
        body: {
          phrase1: "Transférer la propriété de ",
          thisGroup: "ce groupe",
          phrase2: "à",
          thisUser: "cet utilisateur",
          phrase3:
            "? Vous ne serez plus propriétaire du groupe. Le mot de passe du compte est requis pour continuer.",
        },
        labels: {
          password: "Mot de passe",
        },
        buttons: {
          accept: "Transférer",
          cancel: "Annuler",
        },
      },
      editPerms: {
        title: {
          phrase1: "Modifier le membre",
          thisUser: "Cet utilisateur",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Faire de ",
            thisUser: "cet utilisateur",
            phrase2: "le propriétaire du groupe",
          },
          remove: "Supprimer",
          accept: "Sauvegarder",
          cancel: "Annuler",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Enregistrer",
      saving: "Enregistrement",
      activating: "Activation…",
      activate: "Activer",
      messages: {
        successfulStyleUpdate: "Style mis à jour avec succès",
        unsuccessfulStyleUpdate:
          "Impossible de mettre à jour le style. Veuillez réessayer plus tard",
        successfulLogoUpload: "Logo téléchargé avec succès",
        unsuccessfulLogoUpload:
          "Impossible de télécharger le logo. Veuillez réessayer plus tard",
        successfulLogoRemoval: "Logo supprimé avec succès",
        unsuccessfulLogoRemoval:
          "Impossible de supprimer le logo. Veuillez réessayer plus tard",
        successfulActivate: "Personnalisation de la connexion activée avec succès",
        unsuccessfulActivate:
          "Échec de l'activation de la personnalisation de la connexion. Veuillez réessayer",
        copiedToClipboard: "Copié dans le presse-papiers",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Couleur du cadre",
      },
      siteName: {
        title: "Nom du site",
      },
      useAtLogin: {
        title: "Utiliser à la connexion",
        copyLoginURL: "Copier l'URL de connexion",
      },
      GroupStyleUpgradePrompt: {
        title: "Personnalisation du style du groupe",
        subtitle: "Disponible à partir du niveau 3",
        linkToAvailablePlans: "Mettre à niveau pour débloquer",
        features: {
          frameColor: {
            title: "Palette de couleurs de marque",
            description:
              "Choisissez la couleur principale de votre marque pour unifier en-têtes, boutons et accents dans toute l'interface du groupe",
          },
          siteName: {
            title: "Nom de l'entreprise",
            description:
              "Remplacez l'identité par défaut par le nom de votre entreprise, affiché de manière cohérente sur toutes les pages et composants du groupe",
          },
          logo: {
            title: "Télécharger le logo de l'entreprise",
            description:
              "Téléchargez votre logo pour qu'il apparaisse dans les en-têtes, écrans de connexion et zones d'identité du groupe",
          },
          useAtLogin: {
            title: "Personnalisation de la page de connexion",
            description:
              "Étendez votre identité aux pages de connexion avec des styles personnalisés et des URL de marque pour une reconnaissance utilisateur fluide",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Payé",
    pending: "En attente",
    overdue: "En retard",
    cancelled: "Annulé",
    invoice: "Facture",
    invoices: "Factures",
    download: "Télécharger",
    view: "Voir",
    downloadAll: "Tout télécharger",
    date: "Date",
    myPlan: "Mon forfait",
    availablePlans: "Forfaits disponibles",
    amount: "Montant",
    status: "Statut",
    actions: "Actions",
    page: "Page",
    of: "sur",
    members: "Membres",
    dashboards: "Tableaux de bord",
    devices: "Appareils",
    dataRetention: "Rétention des données",
    dashboardElements: "Éléments du tableau de bord",
    free: "Gratuit",
    unlimited: "Illimité",
    month: "Mois",
    monthly: "Mensuel",
    year: "Année",
    yearly: "Annuel",
    selectPlan: "Sélectionner un forfait",
    search: "Rechercher",
    allStatuses: "Tous les statuts",
    allTime: "Toute période",
    activeFilters: "Filtres actifs",
    last30Days: "30 derniers jours",
    last90Days: "90 derniers jours",
    lastYear: "Année dernière",
    thisYear: "Cette année",
    viewInvoice: "Voir la facture",
    copyInvoice: "Copier la facture",
    copyInvoiceID: "Copier l'ID de la facture",
    notificationAlerts: " Alertes de notification",
    customStyleAndUseAtLogin: "Style personnalisé et utilisation à la connexion",
    included: "Inclus",
    availableOnTier3: "Disponible sur Tier 3",
    off: "de réduction",
    clear: "Effacer",
    next: "Suivant",
    previous: "Précédent",
    cancel: "Annuler",
    all: "Tout",
    downloadFormat: "Format de téléchargement",
    dateFormat: "Format de date",
    months: "Mois",
    years: "Années",
    day: "Jour",
    days: "Jours",
    chooseFormatFor: "Choisir le format pour",
    downloadAllInvoices: "Télécharger toutes les factures",
    noInvoicesAvailable: "Aucune facture disponible",
    noInvoicesDescription:
      "Vous n'avez pas encore de factures. Les factures apparaîtront ici une fois que votre abonnement générera des enregistrements de facturation.",
  },
  groupAuditLogs: {
    refresh: "Rafraîchir",
    refreshing: "Actualisation...",
    download: "Télécharger",
    user: "Utilisateur",
    resource: "Ressource",
    action: "Action",
    selectDate: "Sélectionner la date",
    filterByUser: "Filtrer par utilisateur",
    filterByResource: "Filtrer par ressource",
    filterByAction: "Filtrer par action",
    clear: "Effacer",
    applyfilter: "Appliquer le filtre",
    show: "Afficher",
    entries: "Entrées",
    email: "E-mail",
    time: "Heure",
    details: "Détails",
    cancel: "Annuler",
    selected: "Sélectionné",
    owner: "Propriétaire",
    member: "Membre",
    previous: "Précédent",
    next: "Suivant",
    of: "de",
    results: "résultats",
    showing: "Affichage",
    to: "à",
    today: "Aujourd'hui",
    thisWeek: "Cette Semaine",
    thisMonth: "Ce mois-ci",
    lastMonth: "Le mois dernier",
    lastYear: "L'année dernière",
    customRange: "Plage personnalisée",
    startDate: "Date de début",
    endDate: "Date de fin",
    date: "Date",
    filterByDate: "Filtrer par date",
  },
};
export const German: LanguageText = {
  createGroup: {
    createAGroup: "Eine Gruppe erstellen",
    createGroup: "Gruppe erstellen",
    labels: {
      groupName: "Gruppenname",
    },
    tooltips: {
      groupName:
        "Füllen Sie diesen Wert automatisch aus, indem Sie auf den Link in der E-Mail klicken, die Sie erhalten haben",
    },
    toasts: {
      createdSuccessfully: "Gruppe erfolgreich erstellt",
      creationError: "Es ist ein Fehler bei der Erstellung der Gruppe aufgetreten",
    },
    confirm: {
      title: "Gruppe erstellen",
      phrase1: "Sind Sie sicher, dass Sie, ",
      phrase2: ", eine Gruppe namens ",
      phrase3: " erstellen möchten?",
      buttons: {
        create: "Erstellen",
        cancel: "Abbrechen",
      },
    },
  },
  groupInvite: {
    inviteUser: "Benutzer einladen",
    email: "E-Mail",
    buttons: {
      admin: "Verwaltung",
      member: "Mitglied",
      invite: "Einladen",
      cancel: "Abbrechen",
    },
    toasts: {
      invited: "Benutzer erfolgreich eingeladen",
    },
  },
  groupTable: {
    groups: "Gruppen",
    groupName: "Gruppenname",
    tableElements: {
      quickEdit: "Schnellbearbeitung",
      searchAllColumns: "Alle Spalten durchsuchen",
      goToPage: "Weiter zur Seite",
      show: "Anzeigen",
      noGroupsFound: "Keine Gruppen gefunden",
    },
  },
  joinGroup: {
    phrase1: "Sind Sie sicher, dass Sie, ",
    phrase2: ", der Gruppe ",
    phrase3: " beitreten möchten?",
    error: {
      thereWasAProblem:
        "Bei der Gruppe, der Sie beitreten möchten, ist ein Fehler aufgetreten. Bitte klicken Sie erneut auf den Link in der E-Mail.",
      ifTheProblemPersists:
        "Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Gruppenadministrator oder",
      pleaseClickEmailLink:
        "Bitte klicken Sie auf den Link in Ihrer E-Mail, um der Gruppe beizutreten",
    },
    modalElements: {
      title: "Gruppe beitreten",
      accept: "Beitreten",
      cancel: "Abmelden",
    },
    toast: {
      joined: "Verbunden",
      successfully: "erfolgreich",
    },
  },
  viewEditGroup: {
    editGroup: "Gruppe bearbeiten",
    labels: {
      groupName: "Gruppenname",
      members: "Mitglieder",
      devices: "Geräte",
    },
    buttons: {
      save: "Speichern",
      cancel: "Abbrechen",
      invite: "Einladen",
      leaveGroup: "Gruppe verlassen",
      deleteGroup: "Gruppe löschen",
    },
    tabs: {
      overview: "Überblick",
      members: "Mitglieder",
      devices: "Geräte",
      dashboards: "Dashboards",
      subscription: "Abonnement",
      notifications: "Benachrichtigungen",
      styles: "Stile",
      logs: "Protokolle",
    },
    toasts: {
      updated: "Gruppe aktualisiert",
      deleted: "Gruppe gelöscht",
      left: "Gruppe verlassen",
    },
    modals: {
      leaveModal: {
        title: "Gruppe verlassen",
        body: {
          phrase1: ", Sind sie Sicher, dass Sie ",
          phrase2: " verlassen möchten?",
        },
        buttons: {
          accept: "Gruppe verlassen",
          cancel: "Abbrechen",
        },
      },
      deleteModal: {
        title: "Gruppe löschen",
        body: {
          phrase1: "Sind Sie sicher, dass Sie die Gruppe ",
          phrase2: (
            <>
              <b> löschen</b> möchten? Dies kann nicht rückgängig gemacht werden.
            </>
          ),
        },
        buttons: {
          accept: "Gruppe löschen",
          cancel: "Abbrechen",
        },
        labels: {
          password: "Passwort",
        },
      },
    },
  },
  memberTable: {
    members: "Mitglieder",
    tableElements: {
      headers: {
        userName: "Nutzername",
        memberID: "Mitglieds-ID",
        joinDate: "Beitrittsdatum",
      },
      quickEdit: "Schnellbearbeitung",
      searchAllColumns: "Alle Spalten durchsuchen",
      goToPage: "Weiter zur Seite",
      show: "Anzeigen",
      loading: "Laden",
      noMembersFound: "Keine Mitglieder gefunden",
    },
    toast: {
      cantEditOwnPerms: "Sie können Ihre eigenen Berechtigungen nicht bearbeiten",
    },
  },
  inviteTable: {
    outstandingInvitations: "Unbeantwortete Einladungen",
    tableElements: {
      headers: {
        email: "E-Mail",
        invitedBy: "Eingeladen von",
        inviteDate: "Einladungsdatum",
        cancelInvitation: "Einladung stornieren",
      },
      noInvitesFound: "Keine Einladungen gefunden",
    },
    toast: {
      cancelSuccess: "Einladung erfolgreich storniert",
      cancelError:
        "Problem bei der Stornierung der Einladung. Bitte versuchen Sie es später noch einmal.",
      updateSuccess: "Einladung erfolgreich aktualisiert",
      updateError:
        "Problem bei der Aktualisierung der Einladung. Bitte versuchen Sie es später noch einmal.",
    },
    modals: {
      cancelInvite: {
        title: "Einladung stornieren",
        body: {
          phrase1: "Sind Sie sicher, dass Sie die Einladungen zu ",
          thisUser: "dieser Benutzer",
          phrase2: " stornieren möchten? Dies entfernt alle Einladungen an ",
          phrase3: ".",
        },
        buttons: {
          accept: "Einladung(en) stornieren",
          cancel: "Abbrechen",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Benutzerberechtigungen aktualisiert",
      removed: "Benutzer aus Gruppe entfernt",
    },
    modals: {
      removeUser: {
        title: "Benutzer entfernen",
        body: {
          phrase1: "",
          thisUser: "dieser Benutzer",
          phrase2: "aus",
          thisGroup: "diese Gruppe",
          phrase3: "entfernen?",
        },
        buttons: {
          accept: "Entfernen",
          cancel: "Abbrechen",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Eigentümerschaft an",
          phrase2: "übertragen",
        },
        body: {
          phrase1: "Eigentum an",
          thisGroup: "dieser Gruppe",
          phrase2: "auf",
          thisUser: "diesen Benutzer",
          phrase3:
            "übertragen? Sie sind dann nicht mehr Eigentümer der Gruppe. Kontopasswort erforderlich, um fortzufahren.",
        },
        labels: {
          password: "Kennwort",
        },
        buttons: {
          accept: "Übertragen",
          cancel: "Abbrechen",
        },
      },
      editPerms: {
        title: {
          phrase1: "Mitglied",
          thisUser: "diesen Benutzer",
          phrase2: "bearbeiten",
        },
        buttons: {
          makeOwner: {
            phrase1: "",
            thisUser: "Dieser Benutzer",
            phrase2: "zum Gruppenbesitzer befördern",
          },
          remove: "Entfernen",
          accept: "Speichern",
          cancel: "Abbrechen",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Speichern",
      saving: "Speichert",
      activating: "Aktivierung…",
      activate: "Aktivieren",
      messages: {
        successfulStyleUpdate: "Stil erfolgreich aktualisiert",
        unsuccessfulStyleUpdate:
          "Stil konnte nicht aktualisiert werden. Bitte versuchen Sie es später erneut",
        successfulLogoUpload: "Logo erfolgreich hochgeladen",
        unsuccessfulLogoUpload:
          "Logo konnte nicht hochgeladen werden. Bitte versuchen Sie es später erneut",
        successfulLogoRemoval: "Logo erfolgreich gelöscht",
        unsuccessfulLogoRemoval:
          "Logo konnte nicht entfernt werden. Bitte versuchen Sie es später erneut",
        successfulActivate: "Anmelde-Anpassung erfolgreich aktiviert",
        unsuccessfulActivate:
          "Anmelde-Anpassung konnte nicht aktiviert werden. Bitte versuchen Sie es erneut",
        copiedToClipboard: "In die Zwischenablage kopiert",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Rahmenfarbe",
      },
      siteName: {
        title: "Seitenname",
      },
      useAtLogin: {
        title: "Bei Anmeldung verwenden",
        copyLoginURL: "Anmelde-URL kopieren",
      },
      GroupStyleUpgradePrompt: {
        title: "Gruppenstil-Anpassung",
        subtitle: "Ab Stufe 3 verfügbar",
        linkToAvailablePlans: "Upgrade zum Freischalten",
        features: {
          frameColor: {
            title: "Markenfarbpalette",
            description:
              "Wählen Sie die Hauptfarbe Ihrer Marke, um Kopfzeilen, Schaltflächen und Akzente in der gesamten Gruppenoberfläche zu vereinheitlichen",
          },
          siteName: {
            title: "Firmenname-Branding",
            description:
              "Ersetzen Sie die Standarddarstellung durch Ihren Firmennamen, der einheitlich auf allen Gruppenseiten und -komponenten angezeigt wird",
          },
          logo: {
            title: "Firmenlogo hochladen",
            description:
              "Laden Sie Ihr Firmenlogo hoch, damit es in Kopfzeilen, Anmeldebildschirmen und wichtigen Branding-Bereichen der Gruppe erscheint",
          },
          useAtLogin: {
            title: "Anmeldeseiten-Branding",
            description:
              "Erweitern Sie Ihr Branding auf Anmeldeseiten mit benutzerdefinierten Styles und markenspezifischen URLs für nahtlose Nutzererkennung",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Bezahlt",
    pending: "Ausstehend",
    overdue: "Überfällig",
    cancelled: "Storniert",
    invoice: "Rechnung",
    invoices: "Rechnungen",
    download: "Herunterladen",
    view: "Ansehen",
    downloadAll: "Alles herunterladen",
    date: "Datum",
    myPlan: "Mein Tarif",
    availablePlans: "Verfügbare Tarife",
    amount: "Betrag",
    status: "Status",
    actions: "Aktionen",
    page: "Seite",
    of: "von",
    members: "Mitglieder",
    dashboards: "Dashboards",
    devices: "Geräte",
    dataRetention: "Datenspeicherung",
    dashboardElements: "Dashboard-Elemente",
    free: "Kostenlos",
    unlimited: "Unbegrenzt",
    month: "Monat",
    monthly: "Monatlich",
    year: "Jahr",
    yearly: "Jährlich",
    selectPlan: "Tarif auswählen",
    search: "Suchen",
    allStatuses: "Alle Status",
    allTime: "Gesamter Zeitraum",
    activeFilters: "Aktive Filter",
    last30Days: "Letzte 30 Tage",
    last90Days: "Letzte 90 Tage",
    lastYear: "Letztes Jahr",
    thisYear: "Dieses Jahr",
    viewInvoice: "Rechnung anzeigen",
    copyInvoice: "Rechnung kopieren",
    copyInvoiceID: "Rechnungs-ID kopieren",
    notificationAlerts: "Benachrichtigungswarnungen",
    customStyleAndUseAtLogin: "Benutzerdefinierter Stil & Stil bei Anmeldung",
    included: "Enthalten",
    availableOnTier3: "Verfügbar in Tier 3",
    off: "Rabatt",
    clear: "Löschen",
    next: "Nächste",
    previous: "Vorherige",
    cancel: "Abbrechen",
    all: "Alle",
    downloadFormat: "Download-Format",
    dateFormat: "Datumsformat",
    months: "Monate",
    years: "Jahre",
    day: "Tag",
    days: "Tage",
    chooseFormatFor: "Format auswählen für",
    downloadAllInvoices: "Alle Rechnungen herunterladen",
    noInvoicesAvailable: "Keine Rechnungen verfügbar",
    noInvoicesDescription:
      "Sie haben noch keine Rechnungen. Rechnungen werden hier angezeigt, sobald Ihr Abonnement Abrechnungsdatensätze generiert.",
  },
  groupAuditLogs: {
    refresh: "Aktualisieren",
    refreshing: "Wird aktualisiert",
    download: "Herunterladen",
    user: "Benutzer",
    resource: "Ressource",
    action: "Aktion",
    selectDate: "Datum auswählen",
    filterByUser: "Nach Benutzer filtern",
    filterByResource: "Nach Ressource filtern",
    filterByAction: "Nach Aktion filtern",
    filterByDate: "Nach Datum filtern",
    clear: "Löschen",
    applyfilter: "Filter anwenden",
    show: "Anzeigen",
    entries: "Einträge",
    email: "E-Mail",
    time: "Zeit",
    details: "Details",
    cancel: "Abbrechen",
    selected: "Ausgewählt",
    owner: "Besitzer",
    member: "Mitglied",
    previous: "Vorherige",
    next: "Nächste",
    of: "von",
    results: "ergebnisse",
    showing: "Anzeige",
    to: "bis",
    today: "Heute",
    thisWeek: "Diese Woche",
    thisMonth: "Diesen Monat",
    lastMonth: "Letzten Monat",
    lastYear: "Letztes Jahr",
    customRange: "Benutzerdefinierter Bereich",
    startDate: "Startdatum",
    endDate: "Enddatum",
    date: "Datum",
  },
};
export const Dutch: LanguageText = {
  createGroup: {
    createAGroup: "Creëer een groep",
    createGroup: "Groep creëren",
    labels: {
      groupName: "Groepsnaam",
    },
    tooltips: {
      groupName:
        "Vul deze waarde automatisch in door te klikken op de link in de e-mail die u hebt ontvangen.",
    },
    toasts: {
      createdSuccessfully: "Groep succesvol aangemaakt",
      creationError: "Er is een fout opgetreden bij het aanmaken van de groep",
    },
    confirm: {
      title: "Groep creëren",
      phrase1: "Weet je zeker dat jij, ",
      phrase2: ", een groep wilt aanmaken met de naam ",
      phrase3: "?",
      buttons: {
        create: "Maak",
        cancel: "Annuleren",
      },
    },
  },
  groupInvite: {
    inviteUser: "Gebruiker uitnodigen",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Lid",
      invite: "Uitnodigen",
      cancel: "Annuleren",
    },
    toasts: {
      invited: "Gebruiker succesvol uitgenodigd",
    },
  },
  groupTable: {
    groups: "Groepen",
    groupName: "Groepsnaam",
    tableElements: {
      quickEdit: "Snelle bewerking",
      searchAllColumns: "Doorzoek alle kolommen",
      goToPage: "Ga naar de pagina",
      show: "Toon",
      noGroupsFound: "Geen groepen gevonden",
    },
  },
  joinGroup: {
    phrase1: "Weet je zeker dat je, ",
    phrase2: ", lid wilt worden van ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "Er is een fout opgetreden bij de groep waar u lid van probeert te worden. Klik nogmaals op de link in de e-mail.",
      ifTheProblemPersists:
        "Als het probleem aanhoudt, neem dan contact op met de groepsbeheerder of",
      pleaseClickEmailLink:
        "Klik op de link die naar uw e-mail is gestuurd om lid te worden van de groep.",
    },
    modalElements: {
      title: "Word lid van groep",
      accept: "Doe mee",
      cancel: "Uitloggen",
    },
    toast: {
      joined: "Aangesloten",
      successfully: "succesvol",
    },
  },
  viewEditGroup: {
    editGroup: "Groep bewerken",
    labels: {
      groupName: "Groepsnaam",
      members: "Leden",
      devices: "Apparaten",
    },
    buttons: {
      save: "Opslaan",
      cancel: "Annuleren",
      invite: "Uitnodigen",
      leaveGroup: "Groep verlaten",
      deleteGroup: "Groep verwijderen",
    },
    tabs: {
      overview: "Overzicht",
      members: "Leden",
      devices: "Apparaten",
      dashboards: "Dashboards",
      subscription: "Abonnement",
      notifications: "Meldingen",
      styles: "Stijlen",
      logs: "Logboeken",
    },
    toasts: {
      updated: "Groep bijgewerkt.",
      deleted: "Groep verwijderd.",
      left: "Linkse groep.",
    },
    modals: {
      leaveModal: {
        title: "Groep verlaten",
        body: {
          phrase1: ", weet je zeker dat je ",
          phrase2: " wilt verlaten?",
        },
        buttons: {
          accept: "Groep verlaten",
          cancel: "Annuleren",
        },
      },
      deleteModal: {
        title: "Groep verwijderen",
        body: {
          phrase1: "Weet je zeker dat je ",
          phrase2: (
            <>
              {" "}
              wilt <b>verwijderen</b>? Deze actie kan niet ongedaan worden gemaakt.
            </>
          ),
        },
        buttons: {
          accept: "Groep verwijderen",
          cancel: "Annuleren",
        },
        labels: {
          password: "Wachtwoord",
        },
      },
    },
  },
  memberTable: {
    members: "Leden",
    tableElements: {
      headers: {
        userName: "gebruikersnaam",
        memberID: "Lid ID",
        joinDate: "Datum toetreding",
      },
      quickEdit: "Snelle bewerking",
      searchAllColumns: "Doorzoek alle kolommen",
      goToPage: "Ga naar de pagina",
      show: "Toon",
      loading: "Laden",
      noMembersFound: "Geen leden gevonden",
    },
    toast: {
      cantEditOwnPerms: "U kunt uw eigen rechten niet bewerken",
    },
  },
  inviteTable: {
    outstandingInvitations: "Onbeantwoorde uitnodigingen",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Uitgenodigd door",
        inviteDate: "Uitnodigingsdatum",
        cancelInvitation: "Uitnodiging annuleren",
      },
      noInvitesFound: "Geen uitnodigingen gevonden",
    },
    toast: {
      cancelSuccess: "Uitnodiging succesvol geannuleerd.",
      cancelError:
        "Probleem met het annuleren van de uitnodiging. Probeer het later nog eens.",
      updateSuccess: "Uitnodiging succesvol bijgewerkt.",
      updateError:
        "Probleem met het bijwerken van de uitnodiging. Probeer het later nog eens.",
    },
    modals: {
      cancelInvite: {
        title: "Uitnodiging annuleren",
        body: {
          phrase1: "Weet je zeker dat je de uitnodigingen voor ",
          thisUser: "deze gebruiker",
          phrase2: " wilt annuleren? Dit zal alle uitnodigingen voor ",
          phrase3: " verwijderen.",
        },
        buttons: {
          accept: "Annuleer uitnodiging(en)",
          cancel: "Annuleren",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Gebruikersrechten bijgewerkt",
      removed: "Gebruiker verwijderd uit groep",
    },
    modals: {
      removeUser: {
        title: "Gebruiker verwijderen",
        body: {
          phrase1: "",
          thisUser: "deze gebruiker",
          phrase2: "verwijderen uit",
          thisGroup: "deze groep",
          phrase3: "?",
        },
        buttons: {
          accept: "Verwijderen",
          cancel: "Annuleren",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Eigendom overdragen aan",
          phrase2: "",
        },
        body: {
          phrase1: "Eigendom van",
          thisGroup: "deze groep",
          phrase2: "overdragen aan",
          thisUser: "deze gebruiker",
          phrase3:
            "? U bent niet langer eigenaar van de groep. Account wachtwoord vereist om verder te gaan.",
        },
        labels: {
          password: "Wachtwoord",
        },
        buttons: {
          accept: "Overdragen",
          cancel: "Annuleren",
        },
      },
      editPerms: {
        title: {
          phrase1: "Bewerk lid",
          thisUser: "deze gebruiker",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Promoveer",
            thisUser: "deze gebruiker",
            phrase2: "tot groepseigenaar",
          },
          remove: "Verwijder",
          accept: "Opslaan",
          cancel: "Annuleren",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Opslaan",
      saving: "Bezig met opslaan",
      activating: "Activeren…",
      activate: "Activeren",
      messages: {
        successfulStyleUpdate: "Stijl succesvol bijgewerkt",
        unsuccessfulStyleUpdate: "Kan de stijl niet bijwerken. Probeer het later opnieuw",
        successfulLogoUpload: "Logo succesvol geüpload",
        unsuccessfulLogoUpload: "Kan het logo niet uploaden. Probeer het later opnieuw",
        successfulLogoRemoval: "Logo succesvol verwijderd",
        unsuccessfulLogoRemoval:
          "Kan het logo niet verwijderen. Probeer het later opnieuw",
        successfulActivate: "Aanmeldingsaanpassing succesvol ingeschakeld",
        unsuccessfulActivate:
          "Aanmeldingsaanpassing inschakelen mislukt. Probeer het opnieuw",
        copiedToClipboard: "Gekopieerd naar klembord",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Randkleur",
      },
      siteName: {
        title: "Sitenaam",
      },
      useAtLogin: {
        title: "Gebruiken bij aanmelding",
        copyLoginURL: "Aanmeldings-URL kopiëren",
      },
      GroupStyleUpgradePrompt: {
        title: "Groepsstijl-aanpassing",
        subtitle: "Beschikbaar vanaf niveau 3",
        linkToAvailablePlans: "Upgrade om te ontgrendelen",
        features: {
          frameColor: {
            title: "Merkkleurenpalet",
            description:
              "Kies de primaire kleur van uw merk om koppen, knoppen en accenten in de hele groepsinterface te verenigen",
          },
          siteName: {
            title: "Bedrijfsnaam-branding",
            description:
              "Vervang de standaard branding door uw bedrijfsnaam, consistent weergegeven op alle groepspagina's en -onderdelen",
          },
          logo: {
            title: "Bedrijfslogo uploaden",
            description:
              "Upload uw bedrijfslogo om het te tonen in koppen, aanmeldschermen en belangrijke brandinggebieden van de groep",
          },
          useAtLogin: {
            title: "Branding op aanmeldpagina",
            description:
              "Breid uw branding uit naar aanmeldpagina's met aangepaste stijlen en merk-URL's voor naadloze herkenning door gebruikers",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Betaald",
    pending: "In afwachting",
    overdue: "Achterstallig",
    cancelled: "Geannuleerd",
    invoice: "Factuur",
    invoices: "Facturen",
    download: "Downloaden",
    view: "Bekijken",
    downloadAll: "Alles downloaden",
    date: "Datum",
    myPlan: "Mijn abonnement",
    availablePlans: "Beschikbare abonnementen",
    amount: "Bedrag",
    status: "Status",
    actions: "Acties",
    page: "Pagina",
    of: "van",
    members: "Leden",
    dashboards: "Dashboards",
    devices: "Apparaten",
    dataRetention: "Gegevensbehoud",
    dashboardElements: "Dashboard-elementen",
    free: "Gratis",
    unlimited: "Onbeperkt",
    month: "Maand",
    monthly: "Maandelijks",
    year: "Jaar",
    yearly: "Jaarlijks",
    selectPlan: "Abonnement kiezen",
    search: "Zoeken",
    allStatuses: "Alle statussen",
    allTime: "Alle periodes",
    activeFilters: "Actieve filters",
    last30Days: "Laatste 30 dagen",
    last90Days: "Laatste 90 dagen",
    lastYear: "Vorig jaar",
    thisYear: "Dit jaar",
    viewInvoice: "Factuur bekijken",
    copyInvoice: "Factuur kopiëren",
    copyInvoiceID: "Factuur-ID kopiëren",
    notificationAlerts: "Notificatiewaarschuwingen",
    customStyleAndUseAtLogin: "Aangepaste stijl & stijl bij inloggen",
    included: "Inbegrepen",
    availableOnTier3: "Beschikbaar in Tier 3",
    off: "korting",
    clear: "Wissen",
    next: "Volgende",
    previous: "Vorige",
    cancel: "Annuleren",
    all: "Alle",
    downloadFormat: "Downloadformaat",
    dateFormat: "Datumformaat",
    months: "Maanden",
    years: "Jaren",
    day: "Dag",
    days: "Dagen",
    chooseFormatFor: "Kies formaat voor",
    downloadAllInvoices: "Alle facturen downloaden",
    noInvoicesAvailable: "Geen facturen beschikbaar",
    noInvoicesDescription:
      "U heeft nog geen facturen. Facturen verschijnen hier zodra uw abonnement factureringsrecords genereert.",
  },
  groupAuditLogs: {
    refresh: "Vernieuwen",
    refreshing: "Aan het vernieuwen",
    download: "Downloaden",
    user: "Gebruiker",
    resource: "Bron",
    action: "Actie",
    selectDate: "Datum selecteren",
    filterByUser: "Filter op gebruiker",
    filterByResource: "Filter op bron",
    filterByAction: "Filter op actie",
    filterByDate: "Filter op datum",
    clear: "Wissen",
    applyfilter: "Filter toepassen",
    show: "Tonen",
    entries: "Invoer",
    email: "E-mail",
    time: "Tijd",
    details: "Details",
    cancel: "Annuleren",
    selected: "Geselecteerd",
    owner: "Eigenaar",
    member: "Lid",
    previous: "Vorige",
    next: "Volgende",
    of: "van",
    results: "resultaten",
    showing: "Weergeven",
    to: " t/m",
    today: "Vandaag",
    thisWeek: "Deze week",
    thisMonth: "Deze maand",
    lastMonth: "Vorige maand",
    lastYear: "Vorig jaar",
    customRange: "Aangepast bereik",
    startDate: "Startdatum",
    endDate: "Einddatum",
    date: "Datum",
  },
};
export const Spanish: LanguageText = {
  createGroup: {
    createAGroup: "Crear un grupo",
    createGroup: "Crear grupo",
    labels: {
      groupName: "Nombre del grupo",
    },
    tooltips: {
      groupName:
        "Rellene automáticamente este valor haciendo clic en el enlace del correo electrónico que ha recibido",
    },
    toasts: {
      createdSuccessfully: "Grupo creado con éxito",
      creationError: "Se ha producido un error al crear el grupo",
    },
    confirm: {
      title: "Crear grupo",
      phrase1: "¿Estás seguro, ",
      phrase2: ", de que quieres crear un grupo llamado ",
      phrase3: "?",
      buttons: {
        create: "Crear",
        cancel: "Cancelar",
      },
    },
  },
  groupInvite: {
    inviteUser: "Invitar usuario",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Miembro",
      invite: "Invitar",
      cancel: "Cancelar",
    },
    toasts: {
      invited: "Usuario invitado con éxito",
    },
  },
  groupTable: {
    groups: "Grupos",
    groupName: "Nombre del grupo",
    tableElements: {
      quickEdit: "Edición rápida",
      searchAllColumns: "Buscar en todas las columnas",
      goToPage: "Ir a la página",
      show: "Mostrar",
      noGroupsFound: "No se han encontrado grupos",
    },
  },
  joinGroup: {
    phrase1: "¿Estás seguro de que tú, ",
    phrase2: ", quieres unirte al ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "Se ha producido un error con el grupo al que intentas unirte. Vuelve a hacer clic en el enlace del correo electrónico",
      ifTheProblemPersists:
        "Si el problema persiste, póngase en contacto con el administrador del grupo o",
      pleaseClickEmailLink:
        "Haga clic en el enlace enviado a su correo electrónico para unirse al grupo",
    },
    modalElements: {
      title: "Unirse al grupo",
      accept: "Unirse",
      cancel: "Cerrar sesión",
    },
    toast: {
      joined: "Se unió",
      successfully: "con éxito",
    },
  },
  viewEditGroup: {
    editGroup: "Editar Grupo",
    labels: {
      groupName: "Nombre del grupo",
      members: "Miembros",
      devices: "Dispositivos",
    },
    buttons: {
      save: "Guardar",
      cancel: "Cancelar",
      invite: "Invitar",
      leaveGroup: "Dejar Grupo",
      deleteGroup: "Borrar Grupo",
    },
    tabs: {
      overview: "Visión de conjunto",
      members: "Miembros",
      devices: "Dispositivos",
      dashboards: "Cuadros de mando",
      subscription: "Suscripción",
      notifications: "Notificaciones",
      styles: " Estilos",
      logs: "Registros",
    },
    toasts: {
      updated: "Grupo actualizado",
      deleted: "Grupo eliminado",
      left: "Grupo de izquierda",
    },
    modals: {
      leaveModal: {
        title: "Dejar Grupo",
        body: {
          phrase1: ", ¿estás seguro de que quieres dejar el ",
          phrase2: "?",
        },
        buttons: {
          accept: "Dejar Grupo",
          cancel: "Cancelar",
        },
      },
      deleteModal: {
        title: "Borrar Grupo",
        body: {
          phrase1: (
            <>
              ¿Estás seguro de que quieres <b>borrar</b>{" "}
            </>
          ),
          phrase2: "? Esta acción no se puede deshacer.",
        },
        buttons: {
          accept: "Borrar Grupo",
          cancel: "Cancelar",
        },
        labels: {
          password: "Contraseña",
        },
      },
    },
  },
  memberTable: {
    members: "Miembros",
    tableElements: {
      headers: {
        userName: "nombre de usuario",
        memberID: "ID de miembro",
        joinDate: "Join Date",
      },
      quickEdit: "Edición rápida",
      searchAllColumns: "Buscar en todas las columnas",
      goToPage: "Ir a la página",
      show: "Mostrar",
      loading: "Cargando",
      noMembersFound: "No se han encontrado miembros",
    },
    toast: {
      cantEditOwnPerms: "No puedes editar tus propios permisos",
    },
  },
  inviteTable: {
    outstandingInvitations: "Invitaciones sin respuesta",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Invitado por",
        inviteDate: "Fecha de invitación",
        cancelInvitation: "Cancelar invitación",
      },
      noInvitesFound: "No se han encontrado invitaciones",
    },
    toast: {
      cancelSuccess: "Invitación cancelada con éxito",
      cancelError: "Problema cancelando invitación. Vuelva a intentarlo más tarde",
      updateSuccess: "Invitación actualizada con éxito",
      updateError: "Problema actualizando invitación. Vuelva a intentarlo más tarde",
    },
    modals: {
      cancelInvite: {
        title: "Cancelar invitación",
        body: {
          phrase1: "¿Estás seguro de que quieres cancelar las invitaciones a ",
          thisUser: "este usuario",
          phrase2: "? Esto eliminará todas las invitaciones a ",
          phrase3: ".",
        },
        buttons: {
          accept: "Cancelar invitación(es)",
          cancel: "Cancelar",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Permisos de usuario actualizados",
      removed: "Usuario eliminado del grupo",
    },
    modals: {
      removeUser: {
        title: "Eliminar usuario",
        body: {
          phrase1: "¿Quitar a",
          thisUser: "este usuario",
          phrase2: "del",
          thisGroup: "este grupo",
          phrase3: "?",
        },
        buttons: {
          accept: "Eliminar",
          cancel: "Cancelar",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Transferir propiedad a",
          phrase2: "",
        },
        body: {
          phrase1: "¿Transferir la propiedad de",
          thisGroup: "este grupo",
          phrase2: "a",
          thisUser: "este usuario",
          phrase3:
            "? Ya no tendrás la propiedad del grupo. Se requiere la contraseña de la cuenta para continuar.",
        },
        labels: {
          password: "Contraseña",
        },
        buttons: {
          accept: "Transferir",
          cancel: "Cancelar",
        },
      },
      editPerms: {
        title: {
          phrase1: "Editar Miembro",
          thisUser: "este usuario",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Promover a",
            thisUser: "este usuario",
            phrase2: "a propietario de grupo",
          },
          remove: "Eliminar",
          accept: "Guardar",
          cancel: "Cancelar",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Guardar",
      saving: "Guardando",
      activating: "Activando…",
      activate: "Activar",
      messages: {
        successfulStyleUpdate: "Estilo actualizado correctamente",
        unsuccessfulStyleUpdate:
          "No se pudo actualizar el estilo. Por favor, inténtelo más tarde",
        successfulLogoUpload: "Logo subido correctamente",
        unsuccessfulLogoUpload:
          "No se pudo subir el logo. Por favor, inténtelo más tarde",
        successfulLogoRemoval: "Logo eliminado correctamente",
        unsuccessfulLogoRemoval:
          "No se pudo eliminar el logo. Por favor, inténtelo más tarde",
        successfulActivate: "Personalización de inicio de sesión activada correctamente",
        unsuccessfulActivate:
          "No se pudo activar la personalización de inicio de sesión. Inténtelo de nuevo",
        copiedToClipboard: "Copiado al portapapeles",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Color del marco",
      },
      siteName: {
        title: "Nombre del sitio",
      },
      useAtLogin: {
        title: "Usar en el inicio de sesión",
        copyLoginURL: "Copiar URL de inicio de sesión",
      },
      GroupStyleUpgradePrompt: {
        title: "Personalización del estilo del grupo",
        subtitle: "Disponible en nivel 3 y superiores",
        linkToAvailablePlans: "Actualizar para desbloquear",
        features: {
          frameColor: {
            title: "Paleta de colores de marca",
            description:
              "Elija el color principal de su marca para unificar encabezados, botones y acentos en toda la interfaz del grupo",
          },
          siteName: {
            title: "Nombre de la empresa",
            description:
              "Reemplace la marca predeterminada por el nombre de su empresa, mostrado de forma coherente en todas las páginas y componentes del grupo",
          },
          logo: {
            title: "Subir logo de la empresa",
            description:
              "Suba el logo de su empresa para que aparezca en encabezados, pantallas de inicio de sesión y áreas de marca del grupo",
          },
          useAtLogin: {
            title: "Marca en la página de inicio de sesión",
            description:
              "Extienda su marca a las páginas de inicio de sesión con estilos personalizados y URL de marca para un reconocimiento fluido del usuario",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Pagado",
    pending: "Pendiente",
    overdue: "Atrasado",
    cancelled: "Cancelado",
    invoice: "Factura",
    invoices: "Facturas",
    download: "Descargar",
    view: "Ver",
    downloadAll: "Descargar todo",
    date: "Fecha",
    myPlan: "Mi plan",
    availablePlans: "Planes disponibles",
    amount: "Cantidad",
    status: "Estado",
    actions: "Acciones",
    page: "Página",
    of: "de",
    members: "Miembros",
    dashboards: "Paneles",
    devices: "Dispositivos",
    dataRetention: "Retención de datos",
    dashboardElements: "Elementos del panel",
    free: "Gratis",
    unlimited: "Ilimitado",
    month: "Mes",
    monthly: "Mensual",
    year: "Año",
    yearly: "Anual",
    selectPlan: "Seleccionar plan",
    search: "Buscar",
    allStatuses: "Todos los estados",
    allTime: "Todo el tiempo",
    activeFilters: "Filtros activos",
    last30Days: "Últimos 30 días",
    last90Days: "Últimos 90 días",
    lastYear: "Año pasado",
    thisYear: "Este año",
    viewInvoice: "Ver factura",
    copyInvoice: "Copiar factura",
    copyInvoiceID: "Copiar ID de factura",
    notificationAlerts: "Alertas de notificación",
    customStyleAndUseAtLogin: "Estilo personalizado y uso en inicio de sesión",
    included: "Incluido",
    availableOnTier3: "Disponible en Tier 3",
    off: "de descuento",
    clear: "Limpiar",
    next: "Siguiente",
    previous: "Anterior",
    cancel: "Cancelar",
    all: "Todo",
    downloadFormat: "Formato de descarga",
    dateFormat: "Formato de fecha",
    months: "Meses",
    years: "Años",
    day: "Día",
    days: "Días",
    chooseFormatFor: "Elegir formato para",
    downloadAllInvoices: "Descargar todas las facturas",
    noInvoicesAvailable: "No hay facturas disponibles",
    noInvoicesDescription:
      "Aún no tienes facturas. Las facturas aparecerán aquí una vez que tu suscripción genere registros de facturación.",
  },
  groupAuditLogs: {
    refresh: "Actualizar",
    refreshing: "Actualizando",
    download: "Descargar",
    user: "Usuario",
    resource: "Recurso",
    action: "Acción",
    selectDate: "Seleccionar fecha",
    filterByUser: "Filtrar por usuario",
    filterByResource: "Filtrar por recurso",
    filterByAction: "Filtrar por acción",
    filterByDate: "Filtrar por fecha",
    clear: "Limpiar",
    applyfilter: "Aplicar filtro",
    show: "Mostrar",
    entries: "Entradas",
    email: "Correo electrónico",
    time: "Hora",
    details: "Detalles",
    cancel: "Cancelar",
    selected: "Seleccionado",
    owner: "Propietario",
    member: "Miembro",
    previous: "Anterior",
    next: "Siguiente",
    of: "de",
    results: "resultados",
    showing: "Mostrando",
    to: "a",
    today: "Hoy",
    thisWeek: "Esta semana",
    thisMonth: "Este mes",
    lastMonth: "El mes pasado",
    lastYear: "El año pasado",
    customRange: "Rango personalizado",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    date: "Fecha",
  },
};
export const Italian: LanguageText = {
  createGroup: {
    createAGroup: "Crea un gruppo",
    createGroup: "Crea gruppo",
    labels: {
      groupName: "Nome del gruppo",
    },
    tooltips: {
      groupName:
        "Compilare automaticamente questo valore facendo clic sul link contenuto nell'e-mail ricevuta",
    },
    toasts: {
      createdSuccessfully: "Gruppo creato con successo",
      creationError: "Si è verificato un errore nella creazione del gruppo",
    },
    confirm: {
      title: "Crea gruppo",
      phrase1: "Sei sicuro che tu, ",
      phrase2: ", vuoi creare un gruppo chiamato ",
      phrase3: "?",
      buttons: {
        create: "Creare",
        cancel: "Annulla",
      },
    },
  },
  groupInvite: {
    inviteUser: "Invita utente",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Membro",
      invite: "Invita",
      cancel: "Annulla",
    },
    toasts: {
      invited: "Utente invitato con successo",
    },
  },
  groupTable: {
    groups: "Gruppi",
    groupName: "Nome del gruppo",
    tableElements: {
      quickEdit: "Modifica rapida",
      searchAllColumns: "Cerca in tutte le colonne",
      goToPage: "Vai alla pagina",
      show: "Mostra",
      noGroupsFound: "Nessun gruppo trovato",
    },
  },
  joinGroup: {
    phrase1: "Sei sicuro che tu, ",
    phrase2: ", vuoi unirti al ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "Si è verificato un errore nel gruppo a cui si sta cercando di aderire. Si prega di cliccare nuovamente sul link contenuto nell'e-mail",
      ifTheProblemPersists:
        "Se il problema persiste, contattare l'amministratore del gruppo o",
      pleaseClickEmailLink:
        "Cliccate sul link inviato alla vostra e-mail per unirvi al gruppo",
    },
    modalElements: {
      title: "Unisciti al gruppo",
      accept: "Partecipa",
      cancel: "Disconnettersi",
    },
    toast: {
      joined: "Iscritto",
      successfully: "con successo",
    },
  },
  viewEditGroup: {
    editGroup: "Modifica gruppo",
    labels: {
      groupName: "Nome del gruppo",
      members: "Membri",
      devices: "Dispositivi",
    },
    buttons: {
      save: "Salva",
      cancel: "Annulla",
      invite: "Invita",
      leaveGroup: "Gruppo di congedo",
      deleteGroup: "Elimina gruppo",
    },
    tabs: {
      overview: "Panoramica",
      members: "Membri",
      devices: "Dispositivi",
      dashboards: "Cruscotti",
      subscription: "Sottoscrizione",
      notifications: "Notifiche",
      styles: "Stili",
      logs: "Log",
    },
    toasts: {
      updated: "Gruppo aggiornato",
      deleted: "Gruppo cancellato",
      left: "Gruppo di sinistra",
    },
    modals: {
      leaveModal: {
        title: "Gruppo di congedo",
        body: {
          phrase1: ", sei sicuro di voler lasciare il ",
          phrase2: "?",
        },
        buttons: {
          accept: "Gruppo di congedo",
          cancel: "Annulla",
        },
      },
      deleteModal: {
        title: "Elimina gruppo",
        body: {
          phrase1: (
            <>
              Sei sicuro di voler <b>cancellare</b> il{" "}
            </>
          ),
          phrase2: "? Questa azione non può essere annullata.",
        },
        buttons: {
          accept: "Elimina gruppo",
          cancel: "Annulla",
        },
        labels: {
          password: "Password",
        },
      },
    },
  },
  memberTable: {
    members: "Membri",
    tableElements: {
      headers: {
        userName: "nome utente",
        memberID: "ID membro",
        joinDate: "Data di adesione",
      },
      quickEdit: "Modifica rapida",
      searchAllColumns: "Cerca in tutte le colonne",
      goToPage: "Vai alla pagina",
      show: "Mostra",
      loading: "Caricamento",
      noMembersFound: "Nessun membro trovato",
    },
    toast: {
      cantEditOwnPerms: "Non sei in grado di modificare le tue autorizzazioni",
    },
  },
  inviteTable: {
    outstandingInvitations: "Inviti senza risposta",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Invitato da",
        inviteDate: "Invita Data",
        cancelInvitation: "Annulla invito",
      },
      noInvitesFound: "Nessun invito trovato",
    },
    toast: {
      cancelSuccess: "Invito/i annullato/i con successo",
      cancelError:
        "Problema di annullamento degli inviti. Si prega di riprovare più tardi",
      updateSuccess: "Autorizzazioni utente aggiornate",
      updateError:
        "Problema nell'aggiornamento delle autorizzazioni utente. Si prega di riprovare più tardi",
    },
    modals: {
      cancelInvite: {
        title: "Annulla invito",
        body: {
          phrase1: "Sei sicuro di voler cancellare gli inviti a ",
          thisUser: "questo utente",
          phrase2: "? Questo rimuoverà tutti gli inviti a ",
          phrase3: ".",
        },
        buttons: {
          accept: "Annulla invito/i",
          cancel: "Annulla",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Autorizzazioni utente aggiornate",
      removed: "Utente rimosso dal gruppo",
    },
    modals: {
      removeUser: {
        title: "Rimuovi utente",
        body: {
          phrase1: "Rimuovere",
          thisUser: "questo utente",
          phrase2: "dal",
          thisGroup: "questo gruppo",
          phrase3: "?",
        },
        buttons: {
          accept: "Rimuovere",
          cancel: "Annullare",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Trasferire la proprietà a",
          phrase2: "",
        },
        body: {
          phrase1: "Trasferire la proprietà di",
          thisGroup: "questo gruppo",
          phrase2: "a",
          thisUser: "questo utente",
          phrase3:
            "? L'utente non avrà più la proprietà del gruppo. Per continuare è necessaria la password dell'account.",
        },
        labels: {
          password: "Password di accesso",
        },
        buttons: {
          accept: "Trasferimento",
          cancel: "Annulla",
        },
      },
      editPerms: {
        title: {
          phrase1: "Modifica del membro",
          thisUser: "questo utente",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Promuovi",
            thisUser: "questo utente",
            phrase2: "a proprietario del gruppo",
          },
          remove: "Rimuovere",
          accept: "Salva",
          cancel: "Annulla",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Salva",
      saving: "Salvataggio",
      activating: "Attivazione…",
      activate: "Attiva",
      messages: {
        successfulStyleUpdate: "Stile aggiornato con successo",
        unsuccessfulStyleUpdate: "Impossibile aggiornare lo stile. Riprova più tardi",
        successfulLogoUpload: "Logo caricato con successo",
        unsuccessfulLogoUpload: "Impossibile caricare il logo. Riprova più tardi",
        successfulLogoRemoval: "Logo eliminato con successo",
        unsuccessfulLogoRemoval: "Impossibile rimuovere il logo. Riprova più tardi",
        successfulActivate: "Personalizzazione accesso attivata con successo",
        unsuccessfulActivate:
          "Impossibile attivare la personalizzazione dell'accesso. Riprova",
        copiedToClipboard: "Copiato negli appunti",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Colore della cornice",
      },
      siteName: {
        title: "Nome del sito",
      },
      useAtLogin: {
        title: "Usa all'accesso",
        copyLoginURL: "Copia URL di accesso",
      },
      GroupStyleUpgradePrompt: {
        title: "Personalizzazione stile gruppo",
        subtitle: "Disponibile dal livello 3 in su",
        linkToAvailablePlans: "Passa al piano superiore per sbloccare",
        features: {
          frameColor: {
            title: "Palette colori del brand",
            description:
              "Scegli il colore principale del tuo brand per unificare intestazioni, pulsanti e accenti in tutta l'interfaccia del gruppo",
          },
          siteName: {
            title: "Nome azienda",
            description:
              "Sostituisci il branding predefinito con il nome della tua azienda, visualizzato in modo coerente su tutte le pagine e i componenti del gruppo",
          },
          logo: {
            title: "Carica logo aziendale",
            description:
              "Carica il logo della tua azienda per farlo apparire in intestazioni, schermate di accesso e aree di branding del gruppo",
          },
          useAtLogin: {
            title: "Branding pagina di accesso",
            description:
              "Estendi il tuo branding alle pagine di accesso con stili personalizzati e URL di marca per un riconoscimento utente fluido",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Pagato",
    pending: "In attesa",
    overdue: "In ritardo",
    cancelled: "Annullato",
    invoice: "Fattura",
    invoices: "Fatture",
    download: "Scarica",
    view: "Visualizza",
    downloadAll: "Scarica tutto",
    date: "Data",
    myPlan: "Il mio piano",
    availablePlans: "Piani disponibili",
    amount: "Importo",
    status: "Stato",
    actions: "Azioni",
    page: "Pagina",
    of: "su",
    members: "Membri",
    dashboards: "Cruscotti",
    devices: "Dispositivi",
    dataRetention: "Conservazione dei dati",
    dashboardElements: "Elementi del cruscotto",
    free: "Gratuito",
    unlimited: "Illimitato",
    month: "Mese",
    monthly: "Mensile",
    year: "Anno",
    yearly: "Annuale",
    selectPlan: "Seleziona piano",
    search: "Cerca",
    allStatuses: "Tutti gli stati",
    allTime: "Tutto il tempo",
    activeFilters: "Filtri attivi",
    last30Days: "Ultimi 30 giorni",
    last90Days: "Ultimi 90 giorni",
    lastYear: "Anno scorso",
    thisYear: "Quest'anno",
    viewInvoice: "Visualizza fattura",
    copyInvoice: "Copia fattura",
    copyInvoiceID: "Copia ID fattura",
    notificationAlerts: " Avvisi di notifica",
    customStyleAndUseAtLogin: "Stile personalizzato e uso al login",
    included: "Incluso",
    availableOnTier3: "Disponibile in Tier 3",
    off: "di sconto",
    clear: "Cancella",
    next: "Successivo",
    previous: "Precedente",
    cancel: "Annulla",
    all: "Tutto",
    downloadFormat: "Formato di download",
    dateFormat: "Formato data",
    months: "Mesi",
    years: "Anni",
    day: "Giorno",
    days: "Giorni",
    chooseFormatFor: "Scegli il formato per",
    downloadAllInvoices: "Scarica tutte le fatture",
    noInvoicesAvailable: "Nessuna fattura disponibile",
    noInvoicesDescription:
      "Non hai ancora fatture. Le fatture appariranno qui una volta che il tuo abbonamento genererà record di fatturazione.",
  },
  groupAuditLogs: {
    refresh: "Aggiorna",
    refreshing: "Aggiornamento...",
    download: "Scarica",
    user: "Utente",
    resource: "Risorsa",
    action: "Azione",
    selectDate: "Seleziona data",
    filterByUser: "Filtra per utente",
    filterByResource: "Filtra per risorsa",
    filterByAction: "Filtra per azione",
    filterByDate: "Filtra per data",
    clear: "Cancella",
    applyfilter: "Applica filtro",
    show: "Mostra",
    entries: "Voci",
    email: "Email",
    time: "Ora",
    details: "Dettagli",
    cancel: "Annulla",
    selected: "Selezionato",
    owner: "Proprietario",
    member: "Membro",
    previous: "Precedente",
    next: "Successivo",
    of: "di",
    results: "risultati",
    showing: "Mostrando",
    to: "a",
    today: "Oggi",
    thisWeek: "Questa settimana",
    thisMonth: "Questo mese",
    lastMonth: "Il mese scorso",
    lastYear: "L'anno scorso",
    customRange: "Intervallo personalizzato",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    date: "Data",
  },
};
export const Romanian: LanguageText = {
  createGroup: {
    createAGroup: "Creați un grup",
    createGroup: "Creați un grup",
    labels: {
      groupName: "Numele grupului",
    },
    tooltips: {
      groupName:
        "Completați automat această valoare dând click pe linkul din e-mailul primit",
    },
    toasts: {
      createdSuccessfully: "Grup creat cu succes",
      creationError: "S-a produs o eroare la crearea grupului",
    },
    confirm: {
      title: "Creați un grup",
      phrase1: "Ești sigur că tu, ",
      phrase2: ", dorești să creezi un grup numit d?",
      phrase3: "?",
      buttons: {
        create: "Creați",
        cancel: "Anulează",
      },
    },
  },
  groupInvite: {
    inviteUser: "Invitați un utilizator",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Membru",
      invite: "Invitați",
      cancel: "Anulează",
    },
    toasts: {
      invited: "Utilizator invitat cu succes",
    },
  },
  groupTable: {
    groups: "Grupuri",
    groupName: "Numele grupului",
    tableElements: {
      quickEdit: "Editare rapidă",
      searchAllColumns: "Căutați toate coloanele",
      goToPage: "Mergi la pagina",
      show: "Arată",
      noGroupsFound: "Nu s-au găsit grupuri",
    },
  },
  joinGroup: {
    phrase1: "Ești sigur că tu, ",
    phrase2: ", dorești să te alături ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "S-a produs o eroare cu grupul la care încercați să vă alăturați. Vă rugăm să faceți din nou clic pe link-ul din e-mail.",
      ifTheProblemPersists:
        "Dacă problema persistă, vă rugăm să contactați administratorul grupului sau",
      pleaseClickEmailLink:
        "Vă rugăm să dați click pe linkul trimis pe e-mail pentru a vă alătura grupului.",
    },
    modalElements: {
      title: "Să se alăture grupului",
      accept: "Aderă",
      cancel: "Deconectați-vă",
    },
    toast: {
      joined: "S-a alăturat",
      successfully: "cu succes",
    },
  },
  viewEditGroup: {
    editGroup: "Editare grup",
    labels: {
      groupName: "Numele grupului",
      members: "Membrii",
      devices: "Dispozitive",
    },
    buttons: {
      save: "Salvați",
      cancel: "Anulează",
      invite: "Invitați",
      leaveGroup: "Părăsiți grupul",
      deleteGroup: "Șterge grupul",
    },
    tabs: {
      overview: "Prezentare generală",
      members: "Membrii",
      devices: "Dispozitive",
      dashboards: "Tablouri de bord",
      subscription: "Abonament",
      notifications: "Notificări",
      styles: "Stiluri",
      logs: "Jurnale",
    },
    toasts: {
      updated: "Grup actualizat.",
      deleted: "Grup șters.",
      left: "Grupul de stânga.",
    },
    modals: {
      leaveModal: {
        title: "Părăsiți grupul",
        body: {
          phrase1: ", ești sigur că dorești să părăsești ",
          phrase2: "?",
        },
        buttons: {
          accept: "Părăsiți grupul",
          cancel: "Anulează",
        },
      },
      deleteModal: {
        title: "Șterge grupul",
        body: {
          phrase1: (
            <>
              Sunteți sigur că doriți să <b>ștergeți</b>{" "}
            </>
          ),
          phrase2: "? Această acțiune nu poate fi anulată.",
        },
        buttons: {
          accept: "Șterge grupul",
          cancel: "Anulează",
        },
        labels: {
          password: "Parola",
        },
      },
    },
  },
  memberTable: {
    members: "Membrii",
    tableElements: {
      headers: {
        userName: "nume de utilizator",
        memberID: "ID membru",
        joinDate: "Data aderării",
      },
      quickEdit: "Editare rapidă",
      searchAllColumns: "Căutați toate coloanele",
      goToPage: "Mergi la pagină",
      show: "Arată",
      loading: "Încărcare",
      noMembersFound: "Nu s-au găsit membri",
    },
    toast: {
      cantEditOwnPerms: "Nu puteți să vă editați propriile permisiuni",
    },
  },
  inviteTable: {
    outstandingInvitations: "Invitații fără răspuns",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Invitat de",
        inviteDate: "Invitați data",
        cancelInvitation: "Anulează invitația",
      },
      noInvitesFound: "Nu s-au găsit invitații",
    },
    toast: {
      cancelSuccess: "Invitația a fost anulată cu succes.",
      cancelError:
        "Problemă la anularea invitației. Vă rugăm să încercați din nou mai târziu.",
      updateSuccess: "Permisiunile utilizatorului au fost actualizate cu succes.",
      updateError:
        "Problemă la actualizarea permisiunilor utilizatorului. Vă rugăm să încercați din nou mai târziu.",
    },
    modals: {
      cancelInvite: {
        title: "Anulează invitația",
        body: {
          phrase1: "Ești sigur că vrei să anulezi invitațiile la ",
          thisUser: "acest utilizator",
          phrase2: "? Acest lucru va elimina toate invitațiile la ",
          phrase3: ".",
        },
        buttons: {
          accept: "Anulează invitația(ele)",
          cancel: "Anulează",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Permisiuni de utilizator actualizate",
      removed: "Utilizator eliminat din grup",
    },
    modals: {
      removeUser: {
        title: "Înlăturați utilizatorul",
        body: {
          phrase1: "Eliminați ",
          thisUser: "acest utilizator",
          phrase2: "din",
          thisGroup: "acest grup",
          phrase3: "?",
        },
        buttons: {
          accept: "Înlătură",
          cancel: "Anulează",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Transfer de proprietate către",
          phrase2: "",
        },
        body: {
          phrase1: "Transferați proprietatea",
          thisGroup: "acestui grup",
          phrase2: "către",
          thisUser: "acest utilizator",
          phrase3:
            "? Nu veți mai avea proprietatea asupra grupului. Parola contului este necesară pentru a continua.",
        },
        labels: {
          password: "Parola",
        },
        buttons: {
          accept: "Transfer",
          cancel: "Anulați",
        },
      },
      editPerms: {
        title: {
          phrase1: "Editare membru",
          thisUser: "Acest utilizator",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Promovați-l pe",
            thisUser: "acest utilizator",
            phrase2: "ca proprietar de grup",
          },
          remove: "Eliminați",
          accept: "Salvați",
          cancel: "Anulează",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Salvează",
      saving: "Se salvează",
      activating: "Se activează…",
      activate: "Activează",
      messages: {
        successfulStyleUpdate: "Stil actualizat cu succes",
        unsuccessfulStyleUpdate:
          "Nu am putut actualiza stilul. Vă rugăm să încercați mai târziu",
        successfulLogoUpload: "Logo încărcat cu succes",
        unsuccessfulLogoUpload:
          "Nu am putut încărca logo-ul. Vă rugăm să încercați mai târziu",
        successfulLogoRemoval: "Logo șters cu succes",
        unsuccessfulLogoRemoval:
          "Nu am putut șterge logo-ul. Vă rugăm să încercați mai târziu",
        successfulActivate: "Personalizarea conectării a fost activată cu succes",
        unsuccessfulActivate:
          "Nu s-a putut activa personalizarea conectării. Vă rugăm să încercați din nou",
        copiedToClipboard: "Copiat în clipboard",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Culoarea ramei",
      },
      siteName: {
        title: "Numele site-ului",
      },
      useAtLogin: {
        title: "Utilizare la conectare",
        copyLoginURL: "Copiază URL-ul de conectare",
      },
      GroupStyleUpgradePrompt: {
        title: "Personalizare stil grup",
        subtitle: "Disponibil de la nivelul 3 în sus",
        linkToAvailablePlans: "Faceți upgrade pentru a debloca",
        features: {
          frameColor: {
            title: "Paletă culori de brand",
            description:
              "Alegeți culoarea principală a brandului pentru a unifica anteturi, butoane și accente în întreaga interfață a grupului",
          },
          siteName: {
            title: "Nume companie",
            description:
              "Înlocuiți branding-ul implicit cu numele companiei dvs., afișat consecvent pe toate paginile și componentele grupului",
          },
          logo: {
            title: "Încărcați logo-ul companiei",
            description:
              "Încărcați logo-ul companiei pentru a apărea în anteturi, ecrane de conectare și zone de branding ale grupului",
          },
          useAtLogin: {
            title: "Branding pagină de conectare",
            description:
              "Extindeți branding-ul la paginile de conectare cu stiluri personalizate și URL-uri de brand pentru recunoaștere fluidă a utilizatorului",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Plătit",
    pending: "În așteptare",
    overdue: "Întârziat",
    cancelled: "Anulat",
    invoice: "Factură",
    invoices: "Facturi",
    download: "Descărcați",
    view: "Vizualizați",
    downloadAll: "Descărcați tot",
    date: "Data",
    myPlan: "Planul meu",
    availablePlans: "Planuri disponibile",
    amount: "Sumă",
    status: "Stare",
    actions: "Acțiuni",
    page: "Pagină",
    of: "din",
    members: "Membri",
    dashboards: "Tablouri de bord",
    devices: "Dispozitive",
    dataRetention: "Păstrarea datelor",
    dashboardElements: "Elemente de panou",
    free: "Gratuit",
    unlimited: "Nelimitat",
    month: "Lună",
    monthly: "Lunar",
    year: "An",
    yearly: "Anual",
    selectPlan: "Selectați planul",
    search: "Căutare",
    allStatuses: "Toate stările",
    allTime: "Toată perioada",
    activeFilters: "Filtre active",
    last30Days: "Ultimele 30 de zile",
    last90Days: "Ultimele 90 de zile",
    lastYear: "Anul trecut",
    thisYear: "Anul acesta",
    viewInvoice: "Vizualizați factura",
    copyInvoice: "Copiați factura",
    copyInvoiceID: "Copiați ID factura",
    notificationAlerts: " Alerte de notificare",
    customStyleAndUseAtLogin: "Stil personalizat și utilizare la autentificare",
    included: "Inclus",
    availableOnTier3: "Disponibil în Tier 3",
    off: "reducere",
    clear: "Șterge",
    next: "Următor",
    previous: "Anterior",
    cancel: "Anulează",
    all: "Tot",
    downloadFormat: "Format de descărcare",
    dateFormat: "Format de dată",
    months: "Luni",
    years: "Ani",
    day: "Zi",
    days: "Zile",
    chooseFormatFor: "Alege formatul pentru",
    downloadAllInvoices: "Descarcă toate facturile",
    noInvoicesAvailable: "Nu sunt facturi disponibile",
    noInvoicesDescription:
      "Încă nu aveți facturi. Facturile vor apărea aici odată ce abonamentul dvs. va genera înregistrări de facturare.",
  },
  groupAuditLogs: {
    refresh: "Reîmprospătează",
    refreshing: "Reîmprospătare...",
    download: "Descarcă",
    user: "Utilizator",
    resource: "Resursă",
    action: "Acțiune",
    selectDate: "Selectați data",
    filterByUser: "Filtrează după utilizator",
    filterByResource: "Filtrează după resursă",
    filterByAction: "Filtrează după acțiune",
    filterByDate: "Filtrează după dată",
    clear: "Șterge",
    applyfilter: "Aplică filtrul",
    show: "Arată",
    entries: "Înregistrări",
    email: "Email",
    time: "Timp",
    details: "Detalii",
    cancel: "Anulează",
    selected: "Selectat",
    owner: "Proprietar",
    member: "Membru",
    previous: "Anterior",
    next: "Următor",
    of: "din",
    results: "rezultate",
    showing: "Afișare",
    to: "până la",
    today: "Astăzi",
    thisWeek: "Săptămâna aceasta",
    thisMonth: "Luna aceasta",
    lastMonth: "Luna trecută",
    lastYear: "Anul trecut",
    customRange: "Interval personalizat",
    startDate: "Data de început",
    endDate: "Data de sfârșit",
    date: "Data",
  },
};
export const Portuguese: LanguageText = {
  createGroup: {
    createAGroup: "Criar um grupo",
    createGroup: "Criar Grupo",
    labels: {
      groupName: "Nome do grupo",
    },
    tooltips: {
      groupName:
        "Preencha automaticamente este valor clicando no link no e-mail que recebeu",
    },
    toasts: {
      createdSuccessfully: "Grupo criado com sucesso",
      creationError: "Houve um erro ao criar o grupo",
    },
    confirm: {
      title: "Criar Grupo",
      phrase1: "Tem a certeza que você, ",
      phrase2: ", gostaria de criar um grupo chamado ",
      phrase3: "?",
      buttons: {
        create: "Criar",
        cancel: "Cancelar",
      },
    },
  },
  groupInvite: {
    inviteUser: "Convidar Utilizador",
    email: "Email",
    buttons: {
      admin: "Admin",
      member: "Membro",
      invite: "Convidar",
      cancel: "Cancel",
    },
    toasts: {
      invited: "Utilizador convidado com sucesso",
    },
  },
  groupTable: {
    groups: "Grupos",
    groupName: "Nome do grupo",
    tableElements: {
      quickEdit: "Edição rápida",
      searchAllColumns: "Pesquisar todas as Colunas",
      goToPage: "Ir para a página",
      show: "Mostrar",
      noGroupsFound: "Não foram encontrados grupos",
    },
  },
  joinGroup: {
    phrase1: "Tem a certeza de que, ",
    phrase2: ", gostaria de se juntar ao ",
    phrase3: "?",
    error: {
      thereWasAProblem:
        "Houve um erro com o grupo a que se está a tentar juntar. Por favor, clique novamente na ligação no e-mail",
      ifTheProblemPersists:
        "Se o problema persistir, por favor contacte o administrador do grupo ou",
      pleaseClickEmailLink:
        "Por favor, clique no link enviado para o seu e-mail para se juntar ao grupo",
    },
    modalElements: {
      title: "Junte-se ao grupo",
      accept: "Junte-se",
      cancel: "Logout",
    },
    toast: {
      joined: "Juntos",
      successfully: "com sucesso",
    },
  },
  viewEditGroup: {
    editGroup: "Grupo de edição",
    labels: {
      groupName: "Nome do grupo",
      members: "Membros",
      devices: "Dispositivos",
    },
    buttons: {
      save: "Salvar",
      cancel: "Cancelar",
      invite: "Convidar",
      leaveGroup: "Deixar o grupo",
      deleteGroup: "Eliminar grupo",
    },
    tabs: {
      overview: "Panorâmica",
      members: "Membros",
      devices: "Dispositivos",
      dashboards: "Painéis de instrumentos",
      subscription: "Subscrição",
      notifications: "Notificações",
      styles: "Estilos",
      logs: "Registros",
    },
    toasts: {
      updated: "Grupo actualizado",
      deleted: "Grupo eliminado",
      left: "Grupo da esquerda",
    },
    modals: {
      leaveModal: {
        title: "Deixar o grupo",
        body: {
          phrase1: ", tem a certeza de que gostaria de deixar o ",
          phrase2: "?",
        },
        buttons: {
          accept: "Deixar o grupo",
          cancel: "Cancelar",
        },
      },
      deleteModal: {
        title: "Eliminar grupo",
        body: {
          phrase1: (
            <>
              Tem a certeza de que quer <b>eliminar</b>{" "}
            </>
          ),
          phrase2: "? Esta acção não pode ser desfeita.",
        },
        buttons: {
          accept: "Eliminar grupo",
          cancel: "Cancelar",
        },
        labels: {
          password: "Palavra-passe",
        },
      },
    },
  },
  memberTable: {
    members: "Membros",
    tableElements: {
      headers: {
        userName: "nome de utilizador",
        memberID: "Identificação de Membro",
        joinDate: "Data de adesão",
      },
      quickEdit: "Edição rápida",
      searchAllColumns: "Pesquisar todas as colunas",
      goToPage: "Ir para a página",
      show: "Mostrar",
      loading: "Carregamento",
      noMembersFound: "Nenhum membro encontrado",
    },
    toast: {
      cantEditOwnPerms: "Não é capaz de editar as suas próprias permissões",
    },
  },
  inviteTable: {
    outstandingInvitations: "Convites não respondidos",
    tableElements: {
      headers: {
        email: "Email",
        invitedBy: "Convidado por",
        inviteDate: "Data do convite",
        cancelInvitation: "Cancelar convite",
      },
      noInvitesFound: "Não foram encontrados convites",
    },
    toast: {
      cancelSuccess: "Convite cancelado com sucesso",
      cancelError:
        "Convite de cancelamento do problema. Por favor, tente novamente mais tarde",
      updateSuccess: "Permissões de utilizador actualizadas com sucesso",
      updateError:
        "Houve um problema ao actualizar as permissões do utilizador. Por favor, tente novamente mais tarde",
    },
    modals: {
      cancelInvite: {
        title: "Cancelar convite",
        body: {
          phrase1: "Tem a certeza de que quer cancelar os convites para ",
          thisUser: "este utilizador",
          phrase2: "? Isto irá retirar todos os convites para ",
          phrase3: ".",
        },
        buttons: {
          accept: "Cancelar convite(s)",
          cancel: "Cancelar",
        },
      },
    },
  },
  groupEditUser: {
    toasts: {
      permsEdited: "Permissões de utilização actualizadas",
      removed: "Utilizador retirado do grupo",
    },
    modals: {
      removeUser: {
        title: "Remover Utilizador",
        body: {
          phrase1: "Retirar",
          thisUser: "este utilizador",
          phrase2: "do",
          thisGroup: "este grupo",
          phrase3: "?",
        },
        buttons: {
          accept: "Remover",
          cancel: "Cancelar",
        },
      },
      transferOwner: {
        title: {
          phrase1: "Transferência de propriedade para",
          phrase2: "",
        },
        body: {
          phrase1: "Transferir a propriedade",
          thisGroup: "deste grupo",
          phrase2: "para",
          thisUser: "este utilizador",
          phrase3:
            "? Deixará de ter a propriedade do grupo. Senha de conta necessária para continuar.",
        },
        labels: {
          password: "Senha",
        },
        buttons: {
          accept: "Transferência",
          cancel: "Cancelar",
        },
      },
      editPerms: {
        title: {
          phrase1: "Membro de edição",
          thisUser: "este utilizador",
          phrase2: "",
        },
        buttons: {
          makeOwner: {
            phrase1: "Promover",
            thisUser: "este utilizador",
            phrase2: "a proprietário de grupo",
          },
          remove: "Remover",
          accept: "Guardar",
          cancel: "Cancelar",
        },
      },
    },
  },
  groupStyle: {
    general: {
      save: "Salvar",
      saving: "Salvando",
      activating: "Ativando…",
      activate: "Ativar",
      messages: {
        successfulStyleUpdate: "Estilo atualizado com sucesso",
        unsuccessfulStyleUpdate:
          "Não foi possível atualizar o estilo. Por favor, tente novamente mais tarde",
        successfulLogoUpload: "Logo enviado com sucesso",
        unsuccessfulLogoUpload:
          "Não foi possível enviar o logo. Por favor, tente novamente mais tarde",
        successfulLogoRemoval: "Logo removido com sucesso",
        unsuccessfulLogoRemoval:
          "Não foi possível remover o logo. Por favor, tente novamente mais tarde",
        successfulActivate: "Personalização de login ativada com sucesso",
        unsuccessfulActivate:
          "Falha ao ativar a personalização de login. Tente novamente",
        copiedToClipboard: "Copiado para a área de transferência",
      },
    },
    components: {
      logo: {
        title: "Logo",
      },
      frameColor: {
        title: "Cor da borda",
      },
      siteName: {
        title: "Nome do site",
      },
      useAtLogin: {
        title: "Usar no login",
        copyLoginURL: "Copiar URL de login",
      },
      GroupStyleUpgradePrompt: {
        title: "Personalização do estilo do grupo",
        subtitle: "Disponível no nível 3 e superiores",
        linkToAvailablePlans: "Fazer upgrade para desbloquear",
        features: {
          frameColor: {
            title: "Paleta de cores da marca",
            description:
              "Escolha a cor principal da sua marca para unificar cabeçalhos, botões e destaques em toda a interface do grupo",
          },
          siteName: {
            title: "Nome da empresa",
            description:
              "Substitua a identidade padrão pelo nome da sua empresa, exibido de forma consistente em todas as páginas e componentes do grupo",
          },
          logo: {
            title: "Enviar logo da empresa",
            description:
              "Envie o logo da sua empresa para aparecer em cabeçalhos, telas de login e áreas de identidade do grupo",
          },
          useAtLogin: {
            title: "Identidade na página de login",
            description:
              "Estenda sua identidade às páginas de login com estilos personalizados e URLs de marca para reconhecimento fluido do utilizador",
          },
        },
      },
    },
  },
  groupSubscription: {
    paid: "Pago",
    pending: "Pendente",
    overdue: "Atrasado",
    cancelled: "Cancelado",
    invoice: "Fatura",
    invoices: "Faturas",
    download: "Baixar",
    view: "Visualizar",
    downloadAll: "Baixar tudo",
    date: "Data",
    myPlan: "Meu plano",
    availablePlans: "Planos disponíveis",
    amount: "Valor",
    status: "Status",
    actions: "Ações",
    page: "Página",
    of: "de",
    members: "Membros",
    dashboards: "Painéis",
    devices: "Dispositivos",
    dataRetention: "Retenção de dados",
    dashboardElements: "Elementos do painel",
    free: "Gratuito",
    unlimited: "Ilimitado",
    month: "Mês",
    monthly: "Mensal",
    year: "Ano",
    yearly: "Anual",
    selectPlan: "Selecionar plano",
    search: "Pesquisar",
    allStatuses: "Todos os status",
    allTime: "Todo período",
    activeFilters: "Filtros ativos",
    last30Days: "Últimos 30 dias",
    last90Days: "Últimos 90 dias",
    lastYear: "Ano passado",
    thisYear: "Este ano",
    viewInvoice: "Visualizar fatura",
    copyInvoice: "Copiar fatura",
    copyInvoiceID: "Copiar ID da fatura",
    notificationAlerts: " Alertas de notificação",
    customStyleAndUseAtLogin: "Estilo personalizado e uso no login",
    included: "Incluído",
    availableOnTier3: "Disponível no Tier 3",
    off: "de desconto",
    clear: "Limpar",
    next: "Seguinte",
    previous: "Anterior",
    cancel: "Cancelar",
    all: "Todos",
    downloadFormat: "Formato de download",
    dateFormat: "Formato de data",
    months: "Meses",
    years: "Anos",
    day: "Dia",
    days: "Dias",
    chooseFormatFor: "Escolher formato para",
    downloadAllInvoices: "Baixar todas as faturas",
    noInvoicesAvailable: "Nenhuma fatura disponível",
    noInvoicesDescription:
      "Você ainda não tem faturas. As faturas aparecerão aqui assim que sua assinatura gerar registros de cobrança.",
  },
  groupAuditLogs: {
    refresh: "Atualizar",
    refreshing: "Atualizando...",
    download: "Baixar",
    user: "Usuário",
    resource: "Recurso",
    action: "Ação",
    selectDate: "Selecionar data",
    filterByUser: "Filtrar por usuário",
    filterByResource: "Filtrar por recurso",
    filterByAction: "Filtrar por ação",
    filterByDate: "Filtrar por data",
    clear: "Limpar",
    applyfilter: "Aplicar filtro",
    show: "Mostrar",
    entries: "Entradas",
    email: "Email",
    time: "Hora",
    details: "Detalhes",
    cancel: "Cancelar",
    selected: "Selecionado",
    owner: "Proprietário",
    member: "Membro",
    previous: "Anterior",
    next: "Próximo",
    of: "de",
    results: "resultados",
    showing: "Mostrando",
    to: "até",
    today: "Hoje",
    thisWeek: "Esta semana",
    thisMonth: "Este mês",
    lastMonth: "Mês passado",
    lastYear: "Ano passado",
    customRange: "Intervalo personalizado",
    startDate: "Data de início",
    endDate: "Data de término",
    date: "Data",
  },
};
